/**
 * When #bundler-v3 has content, moves the size guide modal-opener below .product-variant-container.
 */
(function () {
  var slot = document.querySelector(".size-guide-bundler-slot[data-section-id]");
  if (!slot) return;

  var sectionId = slot.dataset.sectionId;
  var productInfo = document.getElementById("ProductInfo-" + sectionId);
  if (!productInfo) return;

  var variantContainer = productInfo.querySelector(".product-variant-container");
  if (!variantContainer) return;

  var modalAttr = '#SizeGuideModal-' + sectionId;
  var debounce;
  var domObserverAttached = false;

  function bundlerFilled() {
    var b = document.getElementById("bundler-v3");
    if (!b) return false;
    return b.children.length > 0 || b.innerHTML.trim().length > 0;
  }

  function firstOpener() {
    return variantContainer.querySelector(
      'modal-opener[data-modal="' + modalAttr + '"]'
    );
  }

  function firstSizeGuideWrap() {
    return variantContainer.querySelector(".ss-size-guide-container");
  }

  function sync() {
    var opener = firstOpener();
    if (!opener) return;

    if (bundlerFilled()) {
      if (opener.parentElement !== slot) {
        slot.appendChild(opener);
      }
      slot.hidden = false;
    } else {
      if (opener.parentElement === slot) {
        var wrap = firstSizeGuideWrap();
        if (wrap) {
          wrap.appendChild(opener);
        } else {
          variantContainer.appendChild(opener);
        }
      }
      slot.hidden = true;
    }
  }

  function scheduleSync() {
    clearTimeout(debounce);
    debounce = setTimeout(sync, 80);
  }

  function run() {
    sync();
    if (domObserverAttached) return;
    domObserverAttached = true;
    var mo = new MutationObserver(scheduleSync);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.detail || e.detail.sectionId !== sectionId) return;
    slot = document.querySelector(
      '.size-guide-bundler-slot[data-section-id="' + sectionId + '"]'
    );
    productInfo = document.getElementById("ProductInfo-" + sectionId);
    variantContainer =
      productInfo && productInfo.querySelector(".product-variant-container");
    if (!slot || !variantContainer) return;
    sync();
  });
})();
